import * as React from 'react'
import UrlPattern from 'url-pattern'
import { none, Option, some } from 'widgets-for-react'
import { vacancyDetailPathPattern } from '../route/utils'

export const parseParagraphs = (input: string): string =>
  `<p>${input ? input.replace(/\n{2}/g, '</p><p>').replace(/[\n]/g, '<br />') : ''}</p>`

export const compareString: (a: string, b: string) => number = (a: string, b: string) => {
  return a < b ? -1 : a > b ? 1 : 0
}

export const sluggify: (str: string) => string = (str: string) =>
  str ? str.trim().toLowerCase().replace(/\'/gi, '').replace(/\s/gi, '-').replace(/\-\-/gi, '-') : ''

// A CMS title carries its own markers: `|` splits it over lines, `*bold*` sets a run in
// bold and `_italic_` sets one in italic. Italic is how an editor marks the tagline, which
// is the only place the design still uses the italic face.
export const makeTextItalic = (s: string, i: boolean) => (i ? <i className="tagline">{s}</i> : <>{s}</>)

export const splitInItalics = (s: string) =>
  s
    ? s.split('_').map((part, index) => (
        <React.Fragment key={index}>{makeTextItalic(part, Boolean(index % 2))}</React.Fragment>
      ))
    : ''

export const makeTextBold = (s: string, b: boolean) =>
  s ? !b ? <> {splitInItalics(s)} </> : <b className="weight--bold"> {splitInItalics(s)} </b> : ''

export const splitInBolds = (s: string) =>
  s
    ? s.split('*').map((part, index) => (
        <React.Fragment key={index}>{makeTextBold(part, Boolean(index % 2))}</React.Fragment>
      ))
    : ''

export const titleSplit = (title: string) =>
  title ? title.split('|').map((x, i) => <span key={i}>{splitInBolds(x)}</span>) : ''

export const removeBoldsAndSplits = (title: string) =>
  title ? title.split('|').join('').split('*').join('').split('_').join('') : ''

export const removeBoldsAndSplitsButLastSplit = (title: string) => {
  if (!title) return ''
  const splits = title.split('|')
  const size = splits.length
  const pagetitle = splits
    .slice(0, size - 1)
    .join('')
    .replace(/[*_]/g, '')
    .replace(/\s+/g, ' ')
  const sitetitle = splits[size - 1]
  return pagetitle ? [pagetitle, sitetitle].join('|') : sitetitle
}

// Helper for <select> elements
export const toggleLabelFocus = (elementId: string) => {
  const el = document.querySelector(`#${elementId}`)
  el.parentElement.classList.contains('form__select--focus')
    ? el.parentElement.classList.remove('form__select--focus')
    : el.parentElement.classList.add('form__select--focus')
}

export const dashedToCamelCase = (s: string) => s.split('-').map(capitalize).join('')

export const capitalize = (s) => (s ? s[0].toUpperCase() + s.slice(1) : '')

export function withReference<T1, T2>(obj: T1, callback: (_: T1) => T2): T2 {
  return callback(obj)
}

export function withValue<T1, T2>(obj: T1, callback: (_: T1) => T2): T2 {
  return callback({ ...obj })
}

export function getVacancyIdFromUrl(): Option<string> {
  const match = new UrlPattern(vacancyDetailPathPattern, { segmentValueCharset: 'a-zA-Z0-9-_~ %/' }).match(
    location.pathname
  )
  if (!match || !match.vacancyId) return none()

  return some(match.vacancyId)
}
